// extracted by mini-css-extract-plugin
export default {"noteContainer":"AllariaNote_noteContainer__aOQc6","title":"AllariaNote_title__-Rjzp","description":"AllariaNote_description__0HVWE"};